

































import { defineComponent, computed, useContext } from '@nuxtjs/composition-api';
import { useTranslations } from '@vue-storefront/novulo';
import { addCurrency, getStatusReferenceEnum, priceFormat } from '~/helpers/utils';
import { StatusReference } from '@/helpers/utils';

type PDPProduct = {
  name: string;
  price?: number | null;
  price_after_cash_discount?: number | null;
  price_after_cashback_discount?: number | null;
  status?: string | null;
  status_subtext?: string | null;
  product_image_gallery?: Array<{ media_url?: string; type?: string }>;
  media?: string | null;
  can_be_ordered?: boolean | null;
  status_reference?: number;
};

export default defineComponent({
  name: 'MiniCartDrawerItem',
  props: {
    product: { type: Object as () => PDPProduct, required: true }
  },
  setup(props) {
    const { translate } = useTranslations();
    const { $config } = useContext();
    const mediaBaseURL: string = ($config as any)?.mediaBaseURL || '';

    const productName = computed(() => props.product?.name || '');

    const firstGalleryUrl = computed(() => {
      const url = props.product?.product_image_gallery?.[0]?.media_url;
      return url ? mediaBaseURL + url : null;
    });

    const thumbnail = computed(() => {
      return (
        firstGalleryUrl.value ||
        (props.product && props.product.media ? mediaBaseURL + props.product.media : '')
      );
    });

    const stockText = computed(() => props.product?.status || '');

    const productStatusReference = computed(() => {
      return getStatusReferenceEnum(props.product.status_reference || 0);
    });

    const labelVariant = computed<any>(() => {
      if (
        [
          StatusReference.ON_ORDER,
          StatusReference.PRE_ORDER,
          StatusReference.TEMPORARILY_SOLD_OUT
        ].includes(productStatusReference.value as StatusReference)
      ) {
        return 'soon-available';
      }
      if (props.product?.can_be_ordered === false) {
        return 'not-available';
      }
      return 'available';
    });

    const currentPrice = computed(() => {
      const p = props.product?.price ?? 0;
      const pCash = props.product?.price_after_cash_discount ?? null;
      return pCash && pCash > 0 && pCash < p ? pCash : p;
    });

    const cashbackPrice = computed(() => {
      const cb = props.product?.price_after_cashback_discount ?? null;
      if (cb === null || typeof cb !== 'number') return null;
      return cb < currentPrice.value ? cb : null;
    });

    return {
      translate,
      addCurrency,
      priceFormat,
      productName,
      thumbnail,
      stockText,
      currentPrice,
      cashbackPrice,
      labelVariant
    };
  }
});

